import React from "react";
import { Divider, Typography, Box } from "@mui/material";
import PropTypes from "prop-types";

const MDCCenteredDivider = ({ label }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      <Divider sx={{ flexGrow: 1 }} />
      <Typography sx={{ px: 2 }}>{label}</Typography>
      <Divider sx={{ flexGrow: 1 }} />
    </Box>
  );
};

MDCCenteredDivider.prototype = {
  label: PropTypes.string,
};

export default MDCCenteredDivider;
